// extracted by mini-css-extract-plugin
module.exports = {"inline":"SharedStyles_inline__2uvo5","seven":"SharedStyles_seven__1nbc5","three":"SharedStyles_three__3XXIq","five":"SharedStyles_five__zm8-x"};